<template>
  <div class="ui-filter-checkbox">
    <label class="xs-title">{{ $attrs.name }}</label>
    <div class="checkboxes">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    methods : {
        filterCheck() {
            console.log("ui-filter-checkbox methods");
        }
    },
}
</script>

<style lang="scss" scoped>
.ui-filter-checkbox {
}
.checkboxes {
  margin-top: 1em;
  label {
    margin-bottom: 0.5em;
  }
  & > * {
    display: flex;
    align-items: center;
    input {
      margin-right: 0.5em;
    }
  }
}
.checkboxes label.disabled span.small-text{
  text-decoration: line-through;
}
</style>
